<template>
  <div class="table-responsive">
    <div
      id="zero_config_wrapper"
      class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
    >
      <img :src="testImg" alt="" />
      <div class="row justify-content-between">
        <div class="col-sm-12 col-md-6 ml-auto">
          <div class="dataTables_filter" id="zero_config_filter">
            <label
              >{{ $t("Search")
              }}<input
                type="search"
                v-model="searchQuery"
                class="form-control form-control-sm"
            /></label>
          </div>
        </div>
      </div>
      <div class="row" style="height: 22rem; overflow: auto;" id="test">
        <div class="col-sm-12">
          <table id="zero_config" class="table table-hover">
            <thead>
              <tr>
                <!-- <th style="cursor: pointer; text-align: left">
                  <input
                    type="checkbox"
                    :checked="isAllChecked()"
                    @change="handleAllCheckbox"
                  />
                </th> -->
                <th
                  :key="index"
                  v-for="(column, index) in tableColumns"
                  @click="sortBy(column[1])"
                  style="cursor: pointer; text-align: left"
                >
                  {{ column[0] }}
                  <span
                    class="arrow"
                    :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                  ></span>
                </th>
              </tr>
            </thead>
            <tbody v-if="this.stats.length > 0">
              <tr
                :key="index"
                v-for="(data, index) in paginatedData"
                style="cursor: pointer; text-align: left;"
              >
                <!-- <td style="cursor: pointer; text-align: left">
                  <input
                    type="checkbox"
                    @change="handleCheckbox($event, data)"
                    :checked="isChecked(data)"
                  />
                </td> -->
                <td>{{ data.column1 }}</td>
                <td>{{ data.column2.toLocaleString() }}</td>
                <td v-if="data.date">{{ data.date }}</td>
                <td v-else>
                  {{ $t("no-read") }}
                </td>
              </tr>
            </tbody>
            <tbody v-else align="center">
              <tr align="center">
                <td colspan="6">
                  <!-- {{ $t("no_sms") }} -->
                  <p>{{ $t("no_invoice_yet") }}</p>
                  <p class="gray3">{{ $t("buy_licenses_to_start") }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="this.stats.length !== 0" class="row mb-4">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" id="zero_config_info">
            {{ $t("showing") }}
            {{ (this.pageNumber - 1) * this.sizeperpage + 1 }} {{ $t("to") }}
            {{ this.pageNumber * this.sizeperpage }} of {{ this.stats.length }}
            {{ $t("readings") }}
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li
                class="paginate_button page-item"
                :class="{ active: pageNumber == 1 }"
                @click="pageNumber = 1"
              >
                <a href="#" class="page-link">1</a>
              </li>

              <li
                :class="{ disabled: pageNumber <= 1 }"
                class="paginate_button page-item previous"
                @click="prevPage"
              >
                <a href="#" class="page-link">{{ $t("prev") }}</a>
              </li>

              <div v-if="pageCount > 3" style="display: inherit">
                <li
                  class="paginate_button page-item"
                  :class="{ active: page.isDisabled }"
                  v-for="page in pages"
                  :key="page.name"
                  @click="pageNumber = page.name"
                >
                  <a href="#" class="page-link">{{ page.name }}</a>
                </li>
              </div>

              <li
                class="paginate_button page-item next"
                :class="{ disabled: pageNumber >= pageCount }"
                @click="nextPage"
              >
                <a href="#" class="page-link">{{ $t("next") }}</a>
              </li>
              <li
                class="paginate_button page-item"
                :class="{ active: pageNumber == pageCount }"
                v-if="pageCount > 1"
                @click="pageNumber = pageCount"
              >
                <a href="#" class="page-link">{{ pageCount }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import vClickOutside from "v-click-outside";
import jsPDF from "jspdf";
import { mapGetters, mapActions } from "vuex";
import "jspdf-autotable";

export default {
  name: "InvoicesTable",
  props: {
    stats: Array,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      pageNumber: 1,
      sizeperpage: 10,
      maxVisibleButtons: 3,
      searchQuery: "",
      sortKey: "",
      sortOrders: {},
      // tableColumns: [
      //   [this.$t("date_time"), "column1"],
      //   [this.$t("phone"), "column2"],
      //   [this.$t("num_units"), "column3"],
      //   [this.$t("msg"), "column4"],
      // ],
      dataTable: [],
      checkedItems: [],
      showDropdown: null,
      testImg: "",
    };
  },
  created() {
    let sortOrders = {};
    this.tableColumns.forEach(function(key) {
      sortOrders[key[1]] = 1;
    });
    this.sortOrders = sortOrders;
  },
  watch: {
    stats: {
      handler: function() {
        this.dataTable = [];
        for (let i = 0; i < this.stats.length; i++) {
          let date = this.stats[i].createdAt;
          date = moment(date, "x", true).format("MMM Do YYYY, hh:mm a");
          this.dataTable.push({
            column1: this.stats[i].key,
            column2: this.stats[i].plan.price,
            date: date,
          });
        }
      },
      deep: true,
    },
    expPdf: {
      handler: function() {
        console.log(this.expPdf);
        if (this.expPdf === true) {
          this.exportPDF_();
          this.exportPdf(false);
        }
      },
    },
  },

  computed: {
    ...mapGetters(["businessprofile", "expPdf"]),
    pageCount() {
      let s = this.sizeperpage;

      let data = this.dataTable;
      let l = data.length;
      let count = Math.ceil(l / s);
      let filterKey = this.searchQuery.toLowerCase();
      if (filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
        l = data.length;
        count = Math.ceil(l / s);
      }

      return count;
    },
    paginatedData() {
      let start = (this.pageNumber - 1) * parseFloat(this.sizeperpage);
      let end =
        (this.pageNumber - 1) * parseFloat(this.sizeperpage) +
        parseFloat(this.sizeperpage);
      let data = this.dataTable;
      let sortKey = this.sortKey;
      let filterKey = this.searchQuery.toLowerCase();
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey) {
        data = data.slice().sort(function(a, b) {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      if (filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
      }

      data = data.slice(start, end);

      return data;
    },
    startPage() {
      // When on the first page
      if (this.pageNumber === 1) {
        return 2;
      }
      // When on the last page
      if (this.pageNumber === this.pageCount) {
        return this.pageCount - this.maxVisibleButtons;
      }
      // When in between
      return this.pageNumber - 1;
    },
    pages() {
      const range = [];

      if (this.startPage === 1) {
        //console.log("stsrtd");
        for (
          let i = this.startPage + 1;
          i <=
          Math.min(this.startPage + this.maxVisibleButtons - 1, this.pageCount);
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      } else if (
        this.startPage ===
        this.pageCount - this.maxVisibleButtons + 1
      ) {
        //console.log("gotcha");
        for (
          let i = this.startPage;
          i <=
          Math.min(
            this.startPage + this.maxVisibleButtons - 1,
            this.pageCount - 1
          );
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      } else {
        for (
          let i = this.startPage;
          i <=
          Math.min(this.startPage + this.maxVisibleButtons - 1, this.pageCount);
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      }

      return range;
    },
    tableColumns() {
      return [
        // [this.$t("date_time"), "column1"],
        // [this.$t("phone"), "column2"],
        // [this.$t("num_units"), "column3"],
        // [this.$t("msg"), "column4"],
        [this.$t("serial_no"), "column1"],
        [this.$t("amount"), "column2"],
        [this.$t("date_of_purchase"), "column3"],
      ];
    },
  },
  methods: {
    ...mapActions(["getBusinessProfile", "exportPdf"]),
    nextPage() {
      if (this.pageNumber < this.pageCount) {
        this.pageNumber++;
      }
    },
    prevPage() {
      if (this.pageNumber > 1) {
        this.pageNumber--;
      }
    },
    sortBy: function(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    exportPDF_() {
      var companyImg = this.businessprofile.image;
      let date = new Date();
      var c = document.createElement("canvas");
      var img = document.createElement("img");
      img.crossOrigin = "anonymous";
      img.src = companyImg;
      var imgUrl =
        "data:image/png;base64,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";
      var doc = new jsPDF();
      setTimeout(() => {
        c.height = img.naturalHeight;
        c.width = img.naturalWidth;
        var ctx = c.getContext("2d");

        ctx.drawImage(img, 0, 0, c.width, c.height);
        var base64String = c.toDataURL("image/png");
        var base64Img = base64String.replace(
          /^data:image\/(png|jpg);base64,/,
          ""
        );
        doc.addImage(base64Img, "JPEG", 170, 8, 30, 10);
        doc.addImage(imgUrl, "JPEG", 15, 8, 30, 10);

        doc.setFontSize(9);
        doc.text(`${this.$t("downloaded_on")} ${date.toDateString()}`, 15, 30);

        doc.setFontSize(20);
        doc.setFont("times", "bold");
        doc.text(`${this.businessprofile.name}`, 105, 40, null, null, "center");
        doc.setFontSize(10);
        doc.setFont("times", "normal");
        doc.text(`${this.$t("invoice_table")}`, 105, 50, null, null, "center");
        doc.autoTable({
          head: [
            [
              "",
              this.$t("invoiceTable.serial_no"),
              this.$t("invoiceTable.amount"),
              this.$t("invoiceTable.date"),
            ],
          ],
          body: this.paginatedData.map(({ column1, column2, date }, i) => [
            i + 1,
            column1,
            column2.toLocaleString(),
            date,
          ]),
          startY: 55,
        });
        doc.save(`${this.businessprofile.name}`);
      }, 500);
    },
  },
};
</script>

<style scoped>
td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
}

th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
.edit-drop {
  position: absolute;
  display: flex;
  flex-flow: column;
  right: 4rem;
  top: 2.5rem;
  background: #ffffff;
  /* border: 0.3px solid rgba(183, 195, 205, 0.4); */
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(128, 101, 101, 0.04);
  border-radius: 1px;
  z-index: 2;
  min-width: 12rem;
}
.edit-drop span {
  padding: 0.5rem 2rem;
  border: 0.3px solid rgba(183, 195, 205, 0.4);
  cursor: pointer;
}
.edit-drop span:hover {
  background-color: rgba(236, 236, 236, 0.33);
}
</style>

<i18n>
{
	"en": {
		"Search": "Search",
		"alm_type": "Alarm Type",
		"alm_val": "Alarm Value",
		"batt": "Battery {name}",
		"comment": "Comment",
		"date_time": "Date/Time",
		"dev-name": "Device Name",
		"dev-tag": "Device Tag",
		"dev_imei": "Device IMEI",
		"entries": "entries",
		"last-seen": "Last Seen",
		"msg": "Message",
		"next": "Next",
		"no-dev": "You have no devices yet",
		"no-read": "No readings yet",
		"no-search": "No search result found",
		"no_alm_yet": "You have no alarm yet",
		"no_sms": "You have no sms currently",
		"num_units": "Number of Units",
		"of": "of",
		"phone": "Phone Number",
		"prev": "Previous",
		"readings": "readings",
		"show": "Show",
		"showing": "Showing",
		"stat": "Status",
		"to": "to"
	},
	"es": {
		"Search": "Buscar",
		"alm_type": "Tipo de alarma",
		"alm_val": "Valor de alarma",
		"batt": "Batería {name}",
		"comment": "Comentario",
		"date_time": "Fecha y hora",
		"dev-name": "Nombre del dispositivo",
		"dev-tag": "Etiqueta de dispositivo",
		"dev_imei": "IMEI del dispositivo",
		"entries": "entradas",
		"last-seen": "Ultima vez visto",
		"msg": "Mensaje",
		"next": "Siguiente",
		"no-dev": "Aún no tienes dispositivos",
		"no-read": "Aún no hay lecturas",
		"no-search": "No se encontraron resultados de búsqueda",
		"no_alm_yet": "Todavía no tienes alarma",
		"no_sms": "Actualmente no tienes sms",
		"num_units": "Número de unidades",
		"of": "de",
		"phone": "Número de teléfono",
		"prev": "Anterior",
		"readings": "Lecturas",
		"show": "Show",
		"showing": "Demostración",
		"stat": "Estado",
		"to": "a"
	},
	"fr": {
		"Search": "Chercher",
		"alm_type": "Type d'alarme",
		"alm_val": "VALEUR D'ALARME",
		"batt": "Batterie {name}",
		"comment": "Commentaire",
		"date_time": "Date / heure",
		"dev-name": "Nom de l'appareil",
		"dev-tag": "Balise d'appareil",
		"dev_imei": "IMEI de l'appareil",
		"entries": "Les entrées",
		"last-seen": "Vue la dernière fois",
		"msg": "Message",
		"next": "Suivant",
		"no-dev": "Vous n'avez pas encore d'appareils",
		"no-read": "Pas encore de lectures",
		"no-search": "Aucun résultat de recherche trouvé",
		"no_alm_yet": "Vous n'avez pas encore d'alarme",
		"no_sms": "Vous n'avez pas de sms actuellement",
		"num_units": "Nombre d'unités",
		"of": "De",
		"phone": "Numéro de téléphone",
		"prev": "précédent",
		"readings": "Lectures",
		"show": "Spectacle",
		"showing": "Montrant",
		"stat": "Statut",
		"to": "à"
	},
	"sw": {
		"Search": "Tafuta",
		"alm_type": "Aina ya Kengele",
		"alm_val": "Thamani ya Kengele",
		"batt": "Betri {name}",
		"comment": "Maoni",
		"date_time": "Tarehe/Saa",
		"dev-name": "Jina la kifaa",
		"dev-tag": "Lebo ya Kifaa",
		"dev_imei": "IMEI ya kifaa",
		"entries": "Viingilio",
		"last-seen": "Mara ya mwisho kuonekana",
		"msg": "Ujumbe",
		"next": "Ifuatayo",
		"no-dev": "Bado huna vifaa",
		"no-read": "Bado hakuna masomo",
		"no-search": "Hakuna matokeo ya utafutaji yaliyopatikana",
		"no_alm_yet": "Bado huna kengele",
		"no_sms": "Huna sms kwa sasa",
		"num_units": "Idadi ya Vitengo",
		"of": "ya",
		"phone": "Nambari ya simu",
		"prev": "Hapo awali",
		"readings": "usomaji",
		"show": "Onyesha",
		"showing": "Kuonesha",
		"stat": "Hali",
		"to": "Kwa"
	}
}
</i18n>
